import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { GETTERS as CUSTOMER_GETTERS } from '@/store/customer';
import { isDesktop } from '@/helpers';
import { GETTERS as RESTAURANT_GETTERS } from '@/store/restaurant';
import { NutritionCalculatorPageLoadEvent } from '@/services/analytics/events';
import { MBV2CachedHoverEntree } from '@/models';

@Component({
  name: 'CmgNutritionCalculatorPage',
})
export default class CmgNutritionCalculatorPage extends Vue {
  doneLoading = false;
  lastIsDesktop = false;
  hoveredEntree: MBV2CachedHoverEntree | null = null;

  get selectedRestaurantId(): number {
    return this.$appStore.getters[RESTAURANT_GETTERS.GET_SELECTED_RESTAURANT_ID];
  }

  get isDesktop(): boolean {
    return isDesktop(this.$appStore.state);
  }
  
  @Watch('selectedRestaurantId', { immediate: true, deep: true })
  async onRestaurantChanged(selectedRestaurantId: number) {
    this.doneLoading = false;
    this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
  }

  @Watch('isDesktop', { immediate: true, deep: true })
  async onIsDesktopChanged(isDesktop: boolean) {
    if (this.lastIsDesktop !== isDesktop) {
      this.lastIsDesktop = isDesktop;
      this.doneLoading = false;
      this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
    }
  }

  get showRecents() {
    return this.$appStore.getters[CUSTOMER_GETTERS.IS_LOGGED_IN];
  }

  async mounted() {
    this.lastIsDesktop = this.isDesktop;
    this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
    if (!this.$appStore.state.adobe.hasNutritionCalcPageBeenViewed) {
      this.$services.analytics.send(new NutritionCalculatorPageLoadEvent(this.$appStore.state.ui.countryProfile.countryCode));
    }
  }

  handleEntreeHover(entree: MBV2CachedHoverEntree) {
    this.hoveredEntree = entree ? entree : null;
  }
}
